<template>
  <div class="tag-anchor" :style="styles">
    <div class="tag-anchor__pos" :class="`tag-anchor__pos--tail-${tailPosition}`">
      <div
        :id="_id"
        class="tag-rich"
        :class="classes"
      >
        <div class="tag-rich__inner" :class="{ 'dir-rtl' : dir === 'rtl' }">
          <div class="tag-rich__image-col" v-if="image">
            <img class="tag-rich__image" :src="`${$store.state.assetsPath}${image}`"> 
          </div>
          <div class="tag-rich__content-col" v-if="label">
            <div class="tag-rich__label" v-html="label[lang]"></div>
            <div class="tag-rich__description" v-html="description[lang]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['pos', 'flip', 'label', 'type', 'tail-position', 'description', 'image', 'lang', '_id', 'id', 'dir'],

  computed: {
    classes () {
      let classes = {}
      classes[`tag-rich--tail-${this.tailPosition}`] = true
      classes['tag-rich--flip'] = this.flip || this.forceFlip
      return classes
    },

    forceFlip () {
      return this.tailPosition.includes('left')
    },

    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

.tag-anchor {
  font-size: 1em;
  position: absolute;
  pointer-events: none;
  z-index: 5;

  &__pos {
    height: 0;
    width: 0;

    &--tail-top-left:after,
    &--tail-top-center:after,
    &--tail-top-right:after {
      @include tail3(top, null, $rich-tag-bg-color)
    }

    &--tail-bottom-left:after,
    &--tail-bottom-center:after,
    &--tail-bottom-right:after {
      @include tail3(bottom, null, $rich-tag-bg-color)
    }
  }
}

.tag-rich {
  background-color: transparent;
  box-shadow: $tag-box-shadow;
  color: $rich-tag-font-color;
  cursor: grab;
  font-family: $touchscreen-font;
  font-size: $rich-tag-font-size;
  letter-spacing: .05em;
  line-height: 1.2em;
  pointer-events: auto;
  position: absolute;
  z-index: 5;

  * {
    pointer-events: none;
    user-select: none;
  }

  &--tail-top-left {
    left: -$rich-tag-font-size * 2;
    top: 1em / $rich-tag-font-size + em;
  }

  &--tail-top-center {
    left: 50%;
    top: 1em / $rich-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-top-right {
    right: -$rich-tag-font-size * 2;
    top: 1em / $rich-tag-font-size + em;
  }

  &--tail-bottom-left {
    left: -$rich-tag-font-size * 2;
    bottom: 1em / $rich-tag-font-size + em;
  }

  &--tail-bottom-center {
    left: 50%;
    bottom: 1em / $rich-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-bottom-right {
    right: -$rich-tag-font-size * 2;
    bottom: 1em / $rich-tag-font-size + em;
  }

  &__inner {
    background-color: $rich-tag-bg-color;
    border-radius: $rich-tag-border-radius;
    display: flex;
    min-height: 10em;
    overflow: hidden;

    .tag-rich--flip & {
      flex-direction: row-reverse;
    }
  }

  &__image-col {
    width: 14em;
  }

  &__image {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &__content-col {
    padding: 1em;
    width: 17em;
  }

  &__label {
    font-size: 1.5em;
    font-weight: 600;
    line-height: 1.3em;
    margin-bottom: calc(0.3em / 1.5);
    -webkit-font-smoothing: auto;
  }

  &__description {
    font-size: 1em;
    line-height: 1.2;
  }
}
</style>
